import ButtonContainer from "./ButtonContainer";
import { HelpfulButton as Helpful } from "./ActionButtons/HelpfulButton";
ButtonContainer.Helpful = Helpful;

export default ButtonContainer;
